import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export const calcCvKv = (v100String: string, dpString: string): string => {
    try {
        const dp = new Decimal(dpString);
        const flow = new Decimal(v100String);
        // for  eu/ap = V’100 /sqrt(dPV100/100)
        // for am = V’100 /sqrt(dPV100)
        return new Decimal(flow)
            .dividedBy(dp.squareRoot())
            .toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
